import { deletePushSubscription } from "../controllers/chatController";
import { disablePush } from "./pwa";

// Sign out on this device and go to `to` (the ERP login, or the chat app's own sign-in screen).
export async function signOut(to = "/") {
  // Stop chat push notifications on this device so the next person to sign in here doesn't get them.
  try {
    await Promise.race([
      (async () => {
        const endpoint = await disablePush();
        if (endpoint) await deletePushSubscription(endpoint);
      })(),
      new Promise((resolve) => setTimeout(resolve, 2000)),
    ]);
  } catch {
    /* best effort */
  }
  localStorage.clear();
  window.location.href = to;
}
